<template>
  <div class="contents">
    <div class="d-flex section-title-with-back">
      <img src="@/assets/images/Icon awesome-pen.png" alt width="27.3" height="27.3" />
      <p class="title-bk">ブランド編集</p>
    </div>
    <div class="d-flex section-subtitle-with-back">
      <router-link :to="{ name: 'brand-id-detail', params: { id } }">戻る</router-link>
    </div>
    <div class="d-flex section-subtitle-with-back">
      <a href="/pdf/form_brand.pdf" target="_blank">フォームの説明を確認</a>
    </div>
    <div class="container">
      <ValidationObserver v-slot="{ handleSubmit }">
        <form @submit.prevent="handleSubmit(confirmEdited)" ref="form">
          <table class="table table-form">
            <tbody>
              <tr>
                <th scope="row">法人名（法人ID）</th>
                <td />
                <td>{{ currentCorporationDisplay }}</td>
              </tr>
              <tr>
                <th scope="row">ブランドID</th>
                <td />
                <td>{{ currentBrand.uid }}</td>
              </tr>
              <TextField v-model="currentBrand.name" label="ブランド名" extraRules="required" />
              <TextField
                v-model="currentBrand.nameReading"
                label="ブランド名(フリガナ)"
                placeholder="全角カタカナ"
                extraRules="required"
              />
              <PostalCodeField
                v-model="currentBrand.postalCode"
                @fillAddresses="fillAddresses($event)"
                extraRules="required"
                inputClass="col-lg-4"
              />
              <TextField
                v-model="currentBrand.state"
                extraRules="required"
                label="都道府県 市区町村"
                placeholder="例）京都府京都市中京区笋町"
              />
              <TextField
                v-model="currentBrand.address"
                extraRules="required"
                label="番地・建物名"
                placeholder="例）688 第15長谷ビル5F"
              />
              <TextField
                v-model="currentBrand.phone"
                extraRules="phone_number|required"
                label="電話番号"
                placeholder="例）075-708-8100"
              />
              <TextField
                v-model="currentBrand.fax"
                extraRules="phone_number"
                label="FAX番号"
                placeholder="例）075-708-8101"
              />
              <TextField
                v-model="currentBrand.email"
                extraRules="email"
                label="メールアドレス"
                placeholder="例）sample@tamaishiki.com"
              />
            </tbody>
          </table>
          <div class="text-center">
            <button type="submit" class="btn-confirm">確認</button>
          </div>
        </form>
      </ValidationObserver>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex';
import store from '@/store/index.js';
import { ValidationObserver } from 'vee-validate';
import TextField from '@/components/forms/TextField.vue';
import PostalCodeField from '@/components/forms/PostalCodeField.vue';
import { basicCorporationNameIdPresent } from '@/presenters/fields';

export default {
  props: {
    id: {
      type: [String, Number],
      required: true,
    },
  },
  components: {
    ValidationObserver,
    TextField,
    PostalCodeField,
  },
  beforeRouteEnter(routeTo, routeFrom, next) {
    if (routeTo.params.id) {
      store.dispatch('brand/fetchBrand', routeTo.params.id).then(() => {
        next();
      });
    } else {
      next();
    }
  },
  computed: {
    currentBrand() {
      if (this.brand.editingBrand) {
        return this.brand.editingBrand;
      } else {
        return this.brand.brand;
      }
    },
    currentCorporationDisplay() {
      return basicCorporationNameIdPresent(this.currentBrand.corporation);
    },
    ...mapState(['brand']),
  },
  methods: {
    fillAddresses(addressComponents) {
      this.$logger.debug('addressComponents', addressComponents);
      this.currentBrand.state = addressComponents.city_state;
      this.currentBrand.address = addressComponents.address;
    },
    confirmEdited() {
      this.$logger.debug('Started Editing: ' + JSON.stringify(this.currentBrand));
      this.startEditingBrand(this.currentBrand);
      this.$router.push({ name: 'brand-id-confirm', params: { id: this.id } });
    },
    ...mapActions('brand', ['startEditingBrand']),
  },
};
</script>

<style scoped>
.btn-confirm {
  margin-left: 0px;
}
</style>
